import { routes as wizard } from './pages/wizard'
import { routes as signup } from './pages/signup'
import { routes as auth } from './pages/auth'
import { routes as plans } from './pages/plans'
import { routes as subscribers } from './pages/customers'
import { routes as contracts } from './pages/contracts'
import { routes as settings } from './pages/settings'
import { routes as subscribe } from './pages/subscribe'
import { routes as help } from './pages/help'
import { routes as invoices } from './pages/invoices'
import { routes as payments } from './pages/payments'
import { routes as accessUsers } from './pages/access_users'
import { routes as orders } from './pages/orders'
import { routes as taxes } from './pages/taxes'

export default [ ...wizard, ...auth, ...signup, ...plans, ...subscribers, ...contracts, ...settings, ...subscribe, ...help, ...invoices, ...payments, ...accessUsers, ...orders, ...taxes ]



// WEBPACK FOOTER //
// ./src/app/routes.js